import React, { useState } from "react";
import { get } from "lodash";
import { Box } from "@material-ui/core";
import GridSkeleton from "Components/SkeletonLoader/GridSkeleton";
import { GridNoRecords } from "@progress/kendo-react-grid";
import NoDataFound from "Components/widgets/NoDataFound";
import NoRespond from "Assets/images/empty-state/no-respond-found.svg";
import { CheckinDetailGrid, GridChildDetails } from "./Common";
import { useStyles } from "./styles";

const DetailsGridView = ({
  setExpand,
  sortSelected,
  columnsState,
  checkinData,
  checkInType,
  loader,
  fetchColumn,
  surveyResponseData,
  setSurveyResponseData,
  resPondedId,
}) => {
  const classes = useStyles();
  const [checkedRow, setCheckedRow] = useState([]);
  const initialSort = [
    {
      field: "name",
      dir: "asc",
    },
  ];
  const [sort, setSort] = useState(initialSort);

  const rowRender = (trElement, props) => {
    let trProps = {};
    let rowStyle = {};
    let status = get(props, "dataItem.userStatus", "")
      ? props?.dataItem?.userStatus
      : props?.dataItem?.user?.status;
    if (status === "DEACTIVATED") {
      trProps = { className: "grid-disabled-row" };
    }
    if (
      resPondedId === props?.dataItem?.id ||
      (checkInType === "LEARNING" &&
        resPondedId === props?.dataItem?.user?.id) ||
      props?.dataItem?.isNewRowHighlight
    ) {
      rowStyle = { className: "new-row-border new-row-bg" };
    }

    return React.cloneElement(
      trElement,
      { ...trProps, ...rowStyle },
      trElement.props.children
    );
  };

  const expandChange = (event) => {
    let currentId = event.dataItem.id;
    let data = surveyResponseData.slice();
    let index = data.findIndex((d) => d.id === currentId);
    data[index] = {
      ...data[index],
      expanded: !event.dataItem.expanded,
    };
    if (data?.every((res) => res?.expanded)) {
      setExpand(true);
    }
    if (data?.every((res) => !res?.expanded)) {
      setExpand(false);
    }
    setSurveyResponseData(data);
  };

  return (
    <Box mt={3} className={classes.checkinDetailGrid}>
      {loader?.surveyQuestionWiseLoader ||
      loader?.surveyPeopleWiseLoader ||
      loader?.learningLoader ? (
        <GridSkeleton />
      ) : (
        <CheckinDetailGrid
          rowRender={rowRender}
          data={checkinData || []}
          sort={sort}
          setSort={setSort}
          selectedState={checkedRow}
          setSelectedState={setCheckedRow}
          expandField={
            ["SURVEY", "REQUESTFEEDBACK", "SKILLRATING"].includes(checkInType)
              ? "expanded"
              : false
          }
          onExpandChange={expandChange}
          detail={(e) => (
            <GridChildDetails {...e} sortSelected={sortSelected} />
          )}
        >
          <GridNoRecords>
            <NoDataFound
              noDataCustomImg={NoRespond}
              nodataText="No response found"
            />
          </GridNoRecords>
          {columnsState.map(
            (column) =>
              column.show && fetchColumn(column, checkInType, checkinData)
          )}
        </CheckinDetailGrid>
      )}
    </Box>
  );
};
export default DetailsGridView;
